import { CampaignPopupStatusEnums, CampaignPopupUserTypeEnums } from './share-type'

export const CampaignPopupUserTypeOptions = [
  {
    label: '全部用户',
    text: '全部用户',
    value: CampaignPopupUserTypeEnums.ALL_USER,
  },
  {
    label: '新用户',
    text: '新用户',
    value: CampaignPopupUserTypeEnums.NEW_USER,
  },
  {
    label: '老用户',
    text: '老用户',
    value: CampaignPopupUserTypeEnums.OLD_USER,
  },
  {
    label: '企业用户',
    text: '企业用户',
    value: CampaignPopupUserTypeEnums.CORPORATE_USER,
  },
]

export const CampaignPopupStatusOptions = [
  {
    label: '激活',
    text: '激活',
    value: CampaignPopupStatusEnums.ACTIVE,
  },
  {
    label: '已失效',
    text: '已失效',
    value: CampaignPopupStatusEnums.INACTIVE,
  },
  {
    label: '仅限内部',
    text: '仅限内部',
    value: CampaignPopupStatusEnums.INTERNAL_ONLY,
  },
]
